import styled from 'styled-components'

export const AppLogo = styled.img`
    width: 100px;
    min-height: 0;
    background-size: 0;
`

export const AppLogoLinear = styled.img`
    width: 85px;
    min-height: 0;
    background-size: 0;
    margin: auto;
`